namespace e5 {
    export type SwipeDirection = "left" | "right" | "up" | "down";

    export interface SwipeOptions extends ActorOptions {
        minDistance?: number;
        maxLifetime?: number;
    }

    export class Swipe extends Actor<Pointer, SwipeOptions> {
        public static DEFAULT: SwipeOptions = {
            minDistance: 20,
            maxLifetime: 600
        };

        public onSwipe = e5.Signal.create<[SwipeDirection, Swipe]>();

        public minDistance: number;
        public maxLifetime: number;
        private _direction: SwipeDirection = "left";

        constructor(element: HTMLElement = null, options: SwipeOptions = null) {
            super(element, ActorNonOptions);

            if (options !== ActorNonOptions)
                this.setOptions(options);

            this.onUp.add((pointers) => {
                if (this.count !== 0 || this.pointer.multitouch)
                    return;

                var lifeTime = Actor.lifetime(pointers);
                var pointer = pointers[0];
                if (pointer.distance >= this.minDistance && lifeTime <= this.maxLifetime) {
                    var direction: SwipeDirection = "left";
                    if (Math.abs(pointer.moveX) > Math.abs(pointer.moveY)) {
                        direction = (pointer.x - pointer.originX) > 0 ? "right" : "left";
                    }
                    else {
                        direction = (pointer.y - pointer.originY) > 0 ? "down" : "up";
                    }
                    this._direction = direction;
                    this.onSwipe.dispatch(direction, this);
                }
            });
        }

        public get direction(): SwipeDirection {
            return this._direction;
        }

        public setOptions(options: SwipeOptions) {
            options = ObjectUtil.extend({}, Swipe.DEFAULT, options);
            this.minDistance = options.minDistance;
            this.maxLifetime = options.maxLifetime;
            super.setOptions(options);
        }
    }
}